import { render, staticRenderFns } from "./non-sticky-messages.vue?vue&type=template&id=3479c199"
import script from "./non-sticky-messages.vue?vue&type=script&lang=js"
export * from "./non-sticky-messages.vue?vue&type=script&lang=js"
import style0 from "./non-sticky-messages.vue?vue&type=style&index=0&id=3479c199&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports